export enum SpaceAIPluginType {
  Embedded = 'Embedded',
  Helper = 'Helper'
}
